export function IsObject(value) {
    return (typeof value === 'object') && (value !== null);
}
export function GetProcess() {
    if (globalThis.process) {
        return globalThis.process;
    }
    else {
        throw new Error(`Not on a NodeJS's environment`);
    }
}
//# sourceMappingURL=helpers.js.map